import { Injectable, Type } from '@angular/core';
import { AuthModalComponentEnum } from '../enums';
import { LoginStrategyComponent, SignupStrategyComponent, ResetPasswordFormStrategyComponent } from '../components';
import { IAuthModalDomain } from '../interfaces/auth-modal-component.interface';

@Injectable({ providedIn: 'root' })
export class AuthModalFactory {
  private strategies = new Map<AuthModalComponentEnum, Type<IAuthModalDomain>>([
    [AuthModalComponentEnum.LOGIN, LoginStrategyComponent],
    [AuthModalComponentEnum.SIGNUP, SignupStrategyComponent],
    [AuthModalComponentEnum.RESET_PASSWORD, ResetPasswordFormStrategyComponent],
  ]);

  getStrategy(type: AuthModalComponentEnum): Type<IAuthModalDomain> | null {
    const strategy = this.strategies.get(type);
    if (!strategy) {
      console.error(`[AuthModalFactory] No existe estrategia para el tipo: ${type}`);
      return null;
    }
    return strategy;
  }
}
